<div class="chat-registry-link-block" *ngIf="isReady">
  <button class="chat-registry-link-block__bubble" type="button" [disabled]="!draft" (click)="open()">
    <span class="chat-form-draft-block__visited" *ngIf="draft && visited">Посещена</span>
    <span class="chat-registry-link-block__title">{{ draft?.title || 'Черновик недоступен' }}</span>
    <span class="chat-registry-link-block__route">{{ draft ? 'Открыть и проверить перед сохранением' : 'Попросите агента подготовить форму заново' }}</span>
  </button>
  <span role="alert" *ngIf="error">{{ error }}</span>
</div>
